import React, { useEffect, useState } from "react";
import { Modal, Input, Tooltip } from "antd";
import Button from "../../../components/common/button";
import colors from "../../../share/constants/constants";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const UserListModal = ({ users, open, handleOk }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState(users);

  useEffect(() => {
    const filtered = users.filter((user) => {
      const fullName =
        `${user?.user?.firstName} ${user?.user?.lastName}`.toLowerCase();
      const email = user?.user?.email?.toLowerCase();
      const term = searchTerm.toLowerCase();

      return fullName.includes(term) || email.includes(term);
    });

    setFilteredUsers(filtered);
  }, [searchTerm, users]);

  return (
    <div>
      <Modal
        title="Users"
        open={open}
        onOk={handleOk}
        onCancel={handleOk}
        footer={
          <Button
            title="Done"
            color={colors.primaryPurple}
            className="w-full h-3.8"
            onClick={handleOk}
          />
        }
        className="rounded-lg"
      >
        <div className="mb-1">
          <Input
            prefix={<SearchOutlined />}
            placeholder="Search Users"
            className="rounded-md py-1 px-1"
            allowClear
            size="large"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="max-h-40 space-y-2 overflow-y-auto p-2">
          {filteredUsers.length > 0 ? (
            filteredUsers.map((user, index) => (
              <Tooltip
                placement="top"
                title={"See customer details"}
                key={`view_${index}`}
              >
                <div
                  key={index}
                  className="flex flex-col leading-tight cursor-pointer"
                  onClick={() => navigate(`/main/customers/${user?.user?._id}`)}
                >
                  <span className="font-semibold text-sm">
                    {user?.user?.firstName} {user?.user?.lastName}
                  </span>
                  <span className="text-gray-500 text-xs">
                    {user?.user?.email}
                  </span>
                </div>
              </Tooltip>
            ))
          ) : (
            <div className="text-center text-gray-500">No users found</div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default UserListModal;
